import type mdast from 'mdast';
import { Plugin } from 'unified';

export const newlinesToBreaks: Plugin<[], mdast.Root> = function plugin() {
  return function transform<T extends mdast.Root | mdast.Content>(node: T): T {
    // If this is not a parent node, return as-is.
    if (!('children' in node && Array.isArray(node.children))) {
      return node;
    }

    const children: mdast.Content[] = [];

    node.children.map<mdast.Content>(transform).forEach(child => {
      // If this is not a text node, return as-is.
      if (child.type !== 'text') {
        children.push(child);
        return;
      }

      const lines = child.value.split(/(?:\r\n|\r|\n)/);

      // If this text node has no newlines, return as-is.
      if (lines.length === 1) {
        children.push(child);
        return;
      }

      lines.forEach((line, index) => {
        if (index > 0) {
          children.push({
            type: 'break',
          });
        }

        children.push({
          type: 'text',
          value: line,
        });
      });
    });

    return {
      ...node,
      children,
    };
  };
};
